import React from 'react';
import { Route, Redirect, RouteProps, useLocation } from 'react-router-dom';
import { MessageBar, MessageBarType, initializeIcons } from '@fluentui/react';
import { IUserPermissionService } from './services/UserPermissionService';

// Ensure Fluent UI icons are initialized
initializeIcons();

interface IUserPermsRouteProps extends RouteProps {
    userPermissions: IUserPermissionService;
    children: React.ReactNode;
}

// === Custom admin route wrappers ===
export const DirectorateAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserCanViewDirectorateEntities() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const ProjectAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserCanViewProjectEntities() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const MilestoneAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {(up.UserCanViewDirectorateEntities() || up.UserCanViewProjectEntities() || up.UserCanViewPartnerOrganisationEntities())
            ? children
            : <Redirect to="/not-authorised" />}
    </Route>
);

export const AdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserIsSystemAdmin() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const CustomSectionsAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserIsCustomSectionsAdmin() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const FinancialRiskAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserIsFinancialRiskAdmin() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const RiskAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserCanViewRiskEntities() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const FinancialRiskUserRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserCanViewFinancialRiskEntities() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

export const PartnerOrganisationAdminRoute = ({ userPermissions: up, children, ...props }: IUserPermsRouteProps) => (
    <Route {...props}>
        {up.UserCanViewPartnerOrganisationEntities() ? children : <Redirect to="/not-authorised" />}
    </Route>
);

// === Standard pages ===
export const NotAuthorised = () => (
    <MessageBar messageBarType={MessageBarType.error}>
        Not authorised
    </MessageBar>
);

export const NotFound = () => {
    const location = useLocation();
    return (
        <MessageBar messageBarType={MessageBarType.error}>
            Not found &apos;{location.pathname}&apos;
        </MessageBar>
    );
};
